import React, { useEffect, useMemo, useRef, useState } from "react";
import LoadingWrapper from "components/LoadingWrapper";
import PlatformWrap from "components/PlatformWrap";
import Header from "components/Header";
import ExamMainPagePC from "./platforms/PC";
import PageMHomework from "pages/MHomework";
import useRequest, { errorMessage } from "Utils/useRequest";
import {
    ExamTimeType,
    faceCheck,
    getCurrentTime,
    getExamPaperInfo,
    getExamSettings,
    IAnswer,
    ITopic,
    saveAnswerItem,
    saveExamFileDownloadRecord,
    saveMultiScreen,
    savePaperAnswer,
    submitPaper,
    timeCheck,
    uploadToQiNiu
} from "API";
import { Redirect, useHistory, useRouteMatch } from "react-router-dom";
import moment from "moment";
import _ from "underscore";
import { message, Modal, notification, Spin } from "antd";
import { addBreadcrumb } from "Services/Sentry";
import { Severity } from "@sentry/browser";
import WebCamModal from "../components/WebCamModal";
import useModalHandler from "../../../Utils/useModalHandler";
import { ExamContext } from "./context";
import { useInterval } from "react-use";
import { isTrue } from "../../../Utils/filter";
import useStorage from "../../../Utils/useStorage";
import style from "./style.module.scss";
import UrlList from "./platforms/PC/components/UrlList";
import {
    getMeetingRoomByInvigilation,
    getStudentPhoneFileList,
    multiScreen
} from "../../../API";
import { ResultMessage } from "../../../components/ResultMessage";

const { confirm } = Modal;

interface PageExamMainProps {}

export interface saveAnswer {
    topicId: number;
    topicType: string;
    answers: saveAnswerItem[];
}

export const getSaveAnswer = (answerId: number, content: string) => {
    return { answerId, content, attachment: null };
};

const icon = (
    <svg
        className="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4110"
        width="32"
        height="32">
        <path
            d="M512 179.2l390.4 627.2H128l384-627.2m0-64c-19.2 0-44.8 12.8-51.2 32l-390.4 627.2c-25.6 44.8 6.4 96 51.2 96H896c51.2 0 83.2-57.6 51.2-96l-384-627.2c-6.4-19.2-32-32-51.2-32z"
            fill=""
            p-id="4111"
        />
        <path
            d="M512 640c-19.2 0-32-12.8-32-32v-192c0-19.2 12.8-32 32-32s32 12.8 32 32v192c0 19.2-12.8 32-32 32z"
            fill=""
            p-id="4112"
        />
        <path
            d="M512 723.2m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z"
            fill=""
            p-id="4113"
        />
    </svg>
);

const PageExamMain: React.FC<PageExamMainProps> = () => {
    const reg = /http[s]*\:\/\/niu\.edufe\.com\.cn\/[^\'\"\\\<]*/gi;
    const match = useRouteMatch<{ id: string }>();
    const history = useHistory();
    const currentDoSubmitref = useRef<any>(null);
    const webcamModal = useModalHandler();
    const examId = match.params.id;

    const [data, { loading: examLoading, error }, reloadPaper] = useRequest(
        () => Promise.all([getExamPaperInfo(examId), getCurrentTime()])
    );
    const [examInfo, currentTime] = useMemo(() => data || [], [data]);

    const [examSettings, , refreshExamSettings] = useRequest(() =>
        getExamSettings(examId, examInfo?.id)
    );

    const [meetingRoomInfo, , refreshMeetingRoom] = useRequest(() =>
        getMeetingRoomByInvigilation(examId)
    );

    const [currentTimeLoad, {}, loadCurrentTime] = useRequest(
        () => getCurrentTime(),
        { autoStart: false }
    );

    const [photoList, {}, refreshPhotoList] = useRequest(
        () => getStudentPhoneFileList(examId),
        {},
        [examId]
    );
    const [saveAnswerList, setSaveAnswerList] = useState<saveAnswer[]>([]);

    const [Now, setNow] = useState(moment().format("YYYY-MM-DD HH:mm:ss"));

    const stuNo = localStorage.getItem("user");
    const studentName = localStorage.getItem("studentName");

    const answersContent = _.flatten(
        saveAnswerList.map(item => item.answers)
    ).map(item => item.content); //筛选已做答的题目答案
    const file: any = _.flatten(
        answersContent.map(item => item?.match(reg))
    ).filter(item => item !== null); //获取所有上传附件的url地址

    // 每隔5秒钟刷新考试设置, 检查摄像头等相关状态
    useInterval(refreshExamSettings, 10 * 1000);

    //每隔5秒钟刷新一下腾讯会议号
    useInterval(refreshMeetingRoom, 10 * 1000);

    // 被禁止考试
    useEffect(() => {
        if (!isTrue(examSettings?.ban)) return;

        Modal.info({
            title: "禁考提醒",
            content: `由于您${examSettings?.banInfo}被老师强制禁考，因此您无法查看或继续参与本次考试，如有疑问请联系老师。`
        });

        history.goBack();
    }, [examSettings?.ban]);

    // 限制同时登录
    useEffect(() => {
        if (!isTrue(examSettings?.deviceIpInfo)) return;

        Modal.error({
            title: "您已退出考试",
            content: (
                <div>
                    {studentName}
                    {stuNo} <br />
                    系统检测到您已在其他设备登录
                    <br />
                    1、本考核禁止多台设备同时登录一个账号参加考试，请严格遵守考试的规章制度，诚信考试。如果是密码泄露，请修改密码后重新登录继续参加考试。
                    <br />
                    2、网络不稳定也可能被判定多设备登录，请检查并切换至稳定网络环境后，再继续作答。
                </div>
            ),
            className: style.modal,
            width: 375,
            okText: "我知道了"
        });

        history.goBack();
    }, [examSettings?.deviceIpInfo]);

    useEffect(() => {
        addBreadcrumb("Exam", `学生打开了试卷！`, Severity.Info);
        setInterval(() => {
            loadCurrentTime();
        }, 30000);
    }, []);

    useEffect(() => {
        if (!currentTime) return;
        setNow(
            currentTimeLoad ? currentTimeLoad.dateTime : currentTime.dateTime
        );
    }, [currentTime, currentTimeLoad]);

    // 截止时间
    const examEndTime = useMemo(() => {
        const format = "YYYY-MM-DD HH:mm:ss";
        if (!examSettings || !examSettings.stuStartTime) return "";
        if (examSettings.timeType !== ExamTimeType.Free)
            return examSettings.endTime; // 非自主时间考试, 统一按截止日期算
        return moment(examSettings.stuStartTime)
            .add(examSettings.duration, "minutes")
            .format(format); // 已开始的自主考试, 截止日期为开始考试时间+考试时间
    }, [examSettings]);

    useEffect(() => {
        if (examSettings?.timeType === ExamTimeType.Free) {
            if (moment(Now).add(20, "m").isSame(moment(examEndTime))) {
                Modal.info({
                    title: "东财-白果云提醒您：",
                    content:
                        "距离本场考试结束还有20分钟，若有要求上传附件或图片的考题请抓紧时间完成！",
                    onOk: () =>
                        addBreadcrumb(
                            "Exam",
                            "学生确定了 20 分钟提醒！",
                            Severity.Info
                        )
                });
            }

            if (moment(Now).add(10, "m").isSame(moment(examEndTime))) {
                Modal.info({
                    title: "东财-白果云提醒您：",
                    content: (
                        <div
                            style={{
                                fontWeight: "bold",
                                color: "red"
                            }}>
                            距离本场考试结束还有10分钟，请立即检查本场考试要求上传的附件或图片是否已上传成功；如未上传，请抓紧时间完成。考试结束时仍未上传附件或图片的考题按未作答处理！
                        </div>
                    ),
                    okText: "同意并继续",
                    onOk: () =>
                        addBreadcrumb(
                            "Exam",
                            "学生确定了 10 分钟提醒！",
                            Severity.Info
                        )
                });
            }
        }

        const timer = setTimeout(() => {
            setNow(moment(Now).add(1, "second").format("YYYY-MM-DD HH:mm:ss"));
        }, 1000);

        return function cleanup() {
            clearTimeout(timer);
        };
    }, [Now]);

    // 多选传多个ID，与之前ID做对比，返回点击的ID
    const getDuoxuanSelectId = (topicId: number, answerIds: number[]) => {
        const topic = saveAnswerList.find(topic => topic.topicId === topicId);
        if (topic) {
            const saveAnswers = _.pluck(topic.answers, "answerId");
            return saveAnswers
                .filter(item => !answerIds.includes(item))
                .concat(
                    answerIds.filter(item => !saveAnswers.includes(item))
                )[0];
        } else {
            console.error("错误！");
            return answerIds[0];
        }
    };

    // 试题初始化获取选择答案
    const getSaveAnswers = (answers: IAnswer[], topicType: string) => {
        const list: saveAnswerItem[] = [];
        switch (topicType) {
            case "1":
            case "3":
                // case "4":
                const answer = answers.find(answer => answer.isChoose === "1");
                answer &&
                    list.push(
                        getSaveAnswer(answer.answerId, answer.stuAnswer || "")
                    );
                return list;
            case "4":
                list.push(
                    getSaveAnswer(
                        answers[0].answerId,
                        answers[0].stuAnswer || ""
                    )
                );
                return list;
            case "2":
                answers.forEach(answer => {
                    answer.isChoose === "1" &&
                        list.push(
                            getSaveAnswer(
                                answer.answerId,
                                answer.stuAnswer || ""
                            )
                        );
                });
                return list;
            case "5":
                answers.forEach(answer => {
                    answer.stuAnswer &&
                        list.push(
                            getSaveAnswer(
                                answer.answerId,
                                answer.stuAnswer || ""
                            )
                        );
                });
                return list;
            default:
                return list;
        }
    };

    // 试题初始化获取选择列表
    const getSaveTopic = (topics: ITopic[]) => {
        const list: saveAnswer[] = [];

        topics.forEach(topic => {
            const { topicType, answers, topicId } = topic;
            switch (topicType) {
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                    list.push({
                        topicId,
                        topicType,
                        answers: getSaveAnswers(answers, topicType)
                    });
                    return;
                case "6":
                case "7":
                case "8":
                    list.push(...getSaveTopic(topic.topics));
                    return;
                default:
                    break;
            }
        });
        return list;
    };

    useEffect(() => {
        if (!error) return;
        history.goBack();
    }, [error, history]);

    useEffect(() => {
        if (!examInfo) return;
        setSaveAnswerList(getSaveTopic(examInfo.topics));
    }, [examInfo]);

    const examList = useMemo(() => {
        if (!examInfo) return [];
        const TypeSortList = _.uniq(
            _.map(examInfo.topics, topic => topic.topicType)
        );
        return _.chain(examInfo.topics)
            .groupBy("topicType")
            .sortBy((type, key) =>
                TypeSortList.findIndex(item => item === key.toString())
            )
            .map(list => {
                return { topicType: list[0].topicType, list: list };
            })
            .value();
    }, [examInfo]);

    const second = useMemo(() => {
        return (
            moment(examInfo?.endTime).diff(
                moment(currentTime?.dateTime),
                "second"
            ) * 1000
        );
    }, [currentTime, examInfo]);

    // 倒计时结束无感提交试卷
    function handleOnComplete() {
        const autoModal = Modal.success({
            title: "考试时间到，正在自动交卷...",
            content: (
                <div>
                    <div className={style.title}>
                        当前试卷中您共上传<span> {file.length} </span>个文件
                    </div>
                    <UrlList file={file} />
                </div>
            ),
            className: style.modal1
        });

        addBreadcrumb("Exam", "正在自动交卷！", Severity.Info);

        setTimeout(() => {
            currentDoSubmitref.current().then(() => {
                autoModal.destroy();
            });
        }, 4000);
    }

    // 提交试卷确认
    const handleOnSubmit = async () => {
        const list = await refreshPhotoList();
        if (examInfo?.type === "1") {
            addBreadcrumb("Exam", "弹出是否交卷提示！", Severity.Info);
            confirm({
                title: "确定交卷？",
                content: (
                    <div>
                        <div className={style.title}>
                            当前试卷中您共上传&nbsp;&nbsp;
                            <span>{list?.fileNum || 0}</span>
                            &nbsp;&nbsp;个文件，确认提交后不可修改作答内容，确认要交卷？
                        </div>
                        <UrlList file={file.concat(list?.fileList)} />
                    </div>
                ),
                className: style.modal1,
                okText: "提交",
                cancelText: "继续做答",
                onOk() {
                    doSubmitPaper();
                }
            });
        } else {
            doSubmitPaper();
        }
    };

    // 移动端已交卷，pc端退出当前考试
    useEffect(() => {
        //仅仅线上考试进行此操作
        if (examInfo?.type === "1") {
            if (!isTrue(examSettings?.submitTime)) return;

            const { catchPhoto } = examSettings || {};
            isTrue(catchPhoto) ? webcamModal.open() : history.goBack();
        }
    }, [examSettings?.submitTime, examInfo]);

    // 本地存储切屏次数
    const [isSwitch, setIsSwitch] = useStorage(`isSwitch:${examId}`);

    // 切屏检测
    const handleSwitchScreen = (count: number) => {
        // 仅第一次提示
        if (!isSwitch) {
            Modal.info({
                title: "切屏提醒",
                content:
                    "系统自动记录您离开考试界面的时间及次数，且会将您离开考试界面的详细数据提供给判分老师。"
            });
        }

        setIsSwitch(String(count));
        timeCheck(examId, examInfo?.id).catch(() => null);
    };

    // 双屏检测, 1分钟检测一次
    useEffect(() => {
        let isExtended = false;
        let noticed = false;

        const timeout = setInterval(() => {
            // @ts-ignore
            if (!window.screen.isExtended) {
                isExtended = false;
                return;
            }
            if (isExtended) return; // 如果上一次检测就是双屏，也不记录
            isExtended = true;
            saveMultiScreen(examId, examInfo?.id).catch();

            // 只提醒一次
            if (noticed) return;
            noticed = true;
            notification.warn({
                placement: "bottomRight",
                message:
                    "系统检测到您开启了双屏显示，切会将检测到的情况反馈给监考老师，请关闭双屏模式认真作答。"
            });
        }, 60 * 1000);

        return () => clearInterval(timeout);
    }, []);

    // 保存附件下载记录
    function handleDownload(fileUrl: string) {
        saveExamFileDownloadRecord(examId, examInfo?.id!, fileUrl).catch();
    }

    // 提交试卷
    const doSubmitPaper = async (
        content: string = "提交成功，点击确定返回..."
    ) => {
        const { catchPhoto } = examSettings || {};
        const onOk = isTrue(catchPhoto) ? webcamModal.open : history.goBack;

        try {
            await submitPaper(
                examId,
                examInfo!.id,
                JSON.stringify(saveAnswerList)
            );

            Modal.success({
                title: content,
                okText: "确定",
                onOk
            });
        } catch (err) {
            message.error(errorMessage(err, "提交失败"));
        }
    };

    // 最后一次视频抓拍
    async function saveLastFaceCheck(file: File) {
        try {
            const data = await uploadToQiNiu(file); //获取上传后七牛地址
            await faceCheck(examId, data.url, examInfo?.id);
            history.goBack();
        } catch (e) {
            Modal.error({ content: errorMessage(e) });
        }
    }

    currentDoSubmitref.current = doSubmitPaper;

    const getAnswerList = (
        topicId: number,
        topicType: string,
        answerId: number,
        value: string
    ) => {
        const list = [...saveAnswerList];
        const index = saveAnswerList.findIndex(
            topic => topic.topicId === topicId
        );

        if (index < 0) {
            list.push({
                topicId,
                topicType,
                answers: [getSaveAnswer(answerId, value)]
            });
            return list;
        }

        const topic = list[index];
        const answerIndex = topic.answers.findIndex(
            answer => answer.answerId === answerId
        );

        switch (topicType) {
            case "1":
            case "3":
                list[index].answers = [getSaveAnswer(answerId, value)];
                break;
            case "4":
            case "5":
                if (answerIndex < 0) {
                    list[index].answers.push(getSaveAnswer(answerId, value));
                } else {
                    list[index].answers[answerIndex] = getSaveAnswer(
                        answerId,
                        value
                    );
                }
                break;
            case "2":
                if (answerIndex < 0) {
                    list[index].answers.push(getSaveAnswer(answerId, value));
                } else {
                    list[index].answers.splice(answerIndex, 1);
                }
                break;
            default:
                break;
        }
        return list;
    };

    const handleSaveTopic = async (
        topicId: number,
        topicType: string,
        answerId: number | number[],
        value: string = ""
    ) => {
        const answers: saveAnswerItem[] = [];
        let newAnswerId: number;
        let removeLayer = addLayer(topicId);

        if (_.isArray(answerId)) {
            answerId.forEach(id => {
                answers.push(getSaveAnswer(id, value));
            });
            newAnswerId = getDuoxuanSelectId(topicId, answerId);
        } else {
            answers.push(getSaveAnswer(answerId, value));
            newAnswerId = answerId;
        }
        insertSaveAnswerList(topicId, newAnswerId, value, topicType);
        addBreadcrumb(
            "Exam",
            `提交试题 examId: ${examId} paperId: ${examInfo?.id} topidcId: ${topicId} answers: ${answers} type:${topicType}`,
            Severity.Info
        );
        try {
            await savePaperAnswer(
                examId,
                examInfo!.id,
                topicId,
                answers,
                topicType
            );
            await reloadPaper();
        } catch (err) {
            if (err.isAxiosError && err.message === "Network Error") {
                const msg = "您的网络状态不佳，页面将刷新。";
                message.error(msg);
            } else {
                message.error(errorMessage(err));
            }
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } finally {
            removeLayer?.();
        }
    };

    const insertSaveAnswerList = (
        topicId: number,
        answerId: number,
        content: string,
        topicType: string
    ) => {
        const list = getAnswerList(topicId, topicType, answerId, content);
        setSaveAnswerList(list);
    };

    const addLayer = (id: number) => {
        const targetDom = document.getElementById(id.toString());
        if (!targetDom) return;
        targetDom.setAttribute("style", "position: relative");
        const tmpDiv = document.createElement("div");
        tmpDiv.setAttribute(
            "style",
            "position: absolute; top: 0; right: 0; bottom: 0; left: 0; z-index: 9"
        );
        tmpDiv.onclick = () =>
            message.error(
                "您的作答内容正在保存中，请稍后继续作答，如果持续出现此类错误请刷新页面"
            );
        targetDom.appendChild(tmpDiv);

        function removeLayer() {
            targetDom?.removeAttribute("style");
            targetDom?.removeChild(tmpDiv);
        }

        return removeLayer;
    };

    //检测是否多设备连接
    useEffect(() => {
        // @ts-ignore
        if (window.screen.isExtended) {
            multiScreen(examId, examInfo?.id).catch(e =>
                ResultMessage.error(errorMessage(e))
            );
        }
    }, [examId, examInfo?.id]);

    useEffect(() => {
        if (
            examSettings?.examFlagInfo &&
            examSettings?.examFlagInfo.length > 0
        ) {
            notification.warn({
                icon: icon,
                placement: "bottomRight",
                duration: 10,
                message: (
                    <div>
                        <p>
                            监考老师给出警告：
                            {examSettings?.examFlagInfo},
                            请您按照监考老师的要求做并严格最受考试规则。
                        </p>
                    </div>
                )
            });
        }
    }, [examSettings?.examFlagInfo]);

    return (
        <ExamContext.Provider
            value={{
                isExam: true,
                examId,
                examInfo,
                examSettings,
                handleSwitchScreen,
                handleDownload
            }}>
            <PlatformWrap pc={<Header />} />

            <Spin spinning={examLoading}>
                <LoadingWrapper
                    emptyRender={<Redirect to="/" />}
                    isEmpty={!examInfo}
                    loading={false}>
                    {() => (
                        <PlatformWrap
                            mobile={
                                <PageMHomework
                                    onComplete={handleOnComplete}
                                    now={Now}
                                    examInfo={{
                                        second,
                                        endDateTime: examInfo!.endTime,
                                        examType: examInfo!.type,
                                        title: examInfo!.name
                                    }}
                                    type="exam"
                                    data={examList}
                                    state={1}
                                    onSubmit={handleOnSubmit}
                                    onQuestionChange={handleSaveTopic}
                                />
                            }
                            pc={
                                <ExamMainPagePC
                                    paperId={examInfo?.id}
                                    endDateTime={examInfo!.endTime}
                                    now={Now}
                                    onComplete={handleOnComplete}
                                    examList={examList}
                                    second={second}
                                    submitPaper={handleOnSubmit}
                                    saveTopic={handleSaveTopic}
                                    examPaper={examInfo!}
                                    photoList={photoList}
                                    meetingRoomInfo={meetingRoomInfo}
                                />
                            }
                        />
                    )}
                </LoadingWrapper>
            </Spin>

            <WebCamModal
                visible={webcamModal.visible}
                onOk={saveLastFaceCheck}
                onCancel={history.goBack}
            />
        </ExamContext.Provider>
    );
};

export default PageExamMain;
